export const SURVEY_TEXT = 'Provide feedback about this Learning Experience.'
export const LAUNCH_BUTTON_TEXT = 'Launch Activity'
export const TIER_2_TEXT = 'TIER 2'
